// Module
var code = "<script>let $ctrl</script> <molecule-form-drop-down-revised placeholder=\"{{ $ctrl.getPlaceholder }}\" options=\"$ctrl.items\" disabled=\"$ctrl.disabled\" model=\"$ctrl.model\" callback-on-change=\"$ctrl.callbackOnChange\" required=\"!$ctrl.clearable\"></molecule-form-drop-down-revised> ";
// Exports
module.exports = code;